export default __webpack_public_path__ + "static/media/growth.7491a27a.svg";